import React, { useContext, useCallback } from 'react';
import { dataSender, getRoute, navigateV2, replaceUrl } from '../../../common/utils/router';
import { svgSprite, Img, FieldError } from '../../../hybrid/wrappers';
import CartCounter from '../CartCounter/CartCounter';
import UserContext, { StoreContext, UserProfileContext } from '../../../common/utils/getContext';
import { API_SERVER_URL } from '../../../common/utils/utils';
import { useRouter } from 'next/router';
import styles from './CartItem.module.scss';
import stylesmodal from './style/CartItemModal.module.scss';
import classnames from 'classnames';
import { t } from '../../../common/components/T';
import { LangContext } from '../../../common/decorators/Language';

const CartItem = ({ item, price = false, funcs, type, cartError }) => {
    const router = useRouter();
    const { translation } = useContext(LangContext);
    const { userToken, lang, setAlertData, localization, settings } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext);
    const { cartData, setCartData, deliveryCurrency } = useContext(StoreContext) || {};

    const deleteProduct = async () => {
        if (cartData.id) {
            dataSender(
                `${API_SERVER_URL}/api/v1/shop/carts/${cartData.id}/delete-product?_method=DELETE`,
                'POST',
                { product_id: item.product.id },
                (response) => {
                    setCartData(response.data?.data);
                    if (router.asPath === getRoute('/store/cart') && !response?.data?.data?.items?.length) {
                        navigateV2('/store');
                    }
                },
                () => {
                    setAlertData({
                        type: 'error',
                        cont: true,
                        default: 'error_delete_data'
                    });
                },
                userToken,
                lang,
                deliveryCurrency || profileData?.currency?.code || localization?.currency
            );
        }
    };
    const handleLink = () => {
        window.open(replaceUrl(`/store/product/${item.product.id}`), '_blank');
    };

    const formatView = useCallback(
        (ammount, currency) => {
            switch (settings?.currency_format) {
                case '1':
                case '3':
                    return `${ammount} ${currency}`;
                case '0':
                case '2':
                    return `${currency} ${ammount}`;
            }
        },
        [settings]
    );
    const css = type === 'modal' ? stylesmodal : styles;
    const isUnavailable = item?.product?.product_availability === 'not_in_stock' && cartError;
    const productType = item?.product?.properties?.find((prop) => prop?.name === 'gtshop::type');

    return (
        <div className={css.cartWrapperItem}>
            <div>
                <div className={css.cartWrapperLeft}>
                    <div className={classnames(css.cartItemImage, { [css.cartItemImageNo]: !item?.product?.image })}>
                        {!!item?.product?.image ? (
                            <Img className={css.imageGridItem} src={item?.product?.image?.links?.thumb} alt='image' />
                        ) : (
                            svgSprite('product-no-image')
                        )}
                    </div>
                </div>
                <div className={funcs ? classnames(css.cartWrapperRight, css.cartWrapperRightHeader) : css.cartWrapperRight}>
                    <div className={funcs ? classnames(css.cartItemName, css.cartItemNameHeader) : css.cartItemName}>
                        {productType && productType?.value ? (
                            <p className={css.cartItemProductType}>{productType?.value}</p>
                        ) : null}
                        <div
                            onClick={handleLink}
                            className={classnames(css.cartItemTitle, isUnavailable && css.cartItemTitleRed)}
                        >
                            {item.product.name}
                        </div>
                        <div
                            className={classnames(css.cartItemSetInfo, {
                                [css.dn]: type === 'modal' || item?.product?.type !== 'set'
                            })}
                        >
                            {item.product?.set_products?.map((setProduct) => (
                                <p className={css.cartItemSetProductName} key={setProduct.id}>{`${setProduct?.name} - ${
                                    setProduct?.count
                                } ${t('things-short', 'шт', '/store', translation)}.`}</p>
                            ))}
                        </div>
                        <div className={classnames(css.cartItemPrice, { [css.dn]: type === 'modal' }, css.cartItemPriceCheckout)}>
                            <div className={css.totalPrice}>{item.main_price_for_currency_formatted}</div>
                            <div className={css.totalMarketingPrice}>{item.marketing_price_formatted}</div>
                        </div>
                        {/* {article && (
                            <div className={css.cartItemArticle}>
                                <div className={css.cartItemArticleTitle}>
                                    <T textName='storeArticle' defaultStr='Артикул' page={page || '/store'} />:
                                </div>
                                <div>{item.product.article}</div>
                            </div>
                        )} */}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}
                        className={css.cartItemAfterTitle}
                    >
                        {price && <div className={css.totalPriceModern}>{formatView(item.price, item.currency_symbol)}</div>}
                        {!isUnavailable ? (
                            <CartCounter
                                count={item.quantity}
                                idProduct={item.product.id}
                                funcs={funcs}
                                price={price}
                                type={type}
                            />
                        ) : null}
                        {price ? (
                            <div className={classnames(css.cartItemPrice, css.cartItemPriceGrid)}>
                                <div className={css.totalPrice}>
                                    {formatView(item.price * item.quantity, item.currency_symbol)}
                                </div>
                                <div className={css.totalMarketingPrice}>
                                    {item?.marketing_price_currency ||
                                        formatView(item.marketing_price * item.quantity, item.marketing_currency_symbol)}
                                </div>
                            </div>
                        ) : (
                            <div className={classnames(css.cartItemPrice, { [css.dn]: type !== 'modal' })}>
                                <div className={css.totalPrice}>{item.main_price_for_currency_formatted}</div>
                                <div className={css.totalMarketingPrice}>{item.marketing_price_formatted}</div>
                            </div>
                        )}
                    </div>
                </div>
                <div
                    className={css.cartItemDeleteIconWrap}
                    onClick={funcs && funcs.del ? () => funcs.del(item.product.id) : () => deleteProduct()}
                >
                    {svgSprite('cross', { className: css.cartItemDeleteIcon })}
                </div>
            </div>
            {isUnavailable ? (
                <div className={css.productError}>
                    <FieldError>{cartError}</FieldError>
                </div>
            ) : null}
        </div>
    );
};
export default CartItem;
